import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioFabricaService } from '../usuario-fabrica-service/usuario-fabrica.service';
import { ListaBase } from './../../../shared/crud/ListaBase';
import { EstruturaGridViewBuilder } from './../../../shared/gridview/EstruturaGridViewBuilder';
import { Parametro } from './../../../shared/service-base/parametro';

@Component({
  selector: 'app-usuario-fabrica-lista',
  templateUrl: './usuario-fabrica-lista.component.html',
  styleUrls: ['./usuario-fabrica-lista.component.css']
})
export class UsuarioFabricaListaComponent
  extends ListaBase
  implements OnInit {

  visualizarTotalRegistros: boolean;
  exibirBotaoDetalhes: boolean;
 
  get habilitarExclusao(): boolean {
  const currentUser = JSON.parse(sessionStorage.getItem('currentUser') || '{}');

  const usuario = currentUser && currentUser.username
    ? currentUser.username.toString().trim().toLowerCase()
    : '';

  return usuario === 'admin';
}

  constructor(
    service: UsuarioFabricaService,
    toastr: ToastrService,
    router: Router
  ) {
    super(service, toastr, router);

    this.visualizarTotalRegistros = true;
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 10;
    this.exibirBotaoDetalhes = true;
  }

  ngOnInit() {
    this.buscar();

    this.estrutura = new EstruturaGridViewBuilder()
      .addColuna('nome', 'acessos.usuarioFabrica.nome')
      .addColuna('email', 'E-mail')
      .addColuna('login', 'Login')
      .addColuna('dataUltimoAcesso', 'Último acesso')
      .addColunaBooleanW('ativo', 'Status', '0px')
      .build();
  }

  exportExcel() {
    if (!this.dados || this.dados.length === 0) {
      this.toastr.warning('Não existem dados para exportar.');
      return;
    }

    const header = [
      'Nome',
      'E-mail',
      'Login',
      'Último acesso',
      'Status'
    ].join(';');

    const linhas = this.dados.map(r => {
      return [
        r.nome || '',
        r.email || '',
        r.login || '',
        r.dataUltimoAcesso || '',
        r.ativo ? 'Ativo' : 'Inativo'
      ].join(';');
    });

    const conteudo = [header, ...linhas].join('\n');
    const blob = new Blob(['\ufeff' + conteudo], {
      type: 'text/csv;charset=utf-8;'
    });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'usuarios-fabrica.csv';
    link.click();
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.id
      || this.filtros.nome
      || this.filtros.login
      || this.filtros.email
      || this.filtros.status;
  }

  protected carregarModel(registro: any): Promise<any> {
    const parametros: Parametro[] = [];
    const param = new Parametro('id', registro.registro.id);
    parametros.push(param);

    this.carregando = true;

    return this.service.get(parametros)
      .then(res => {
        const retorno: any = {};
        retorno.novoCadastro = false;
        retorno.registro = res.dados[0];
        this.carregando = false;

        return retorno;
      })
      .catch(error => {
        this.tratarErro('Não foi posível carregar o registro', 'Erro', error);
      });
  }
}